<div [ngClass]="extraClass" class="flex flex-auto flex-row content-center items-center justify-start gap-4">
  @if (currentIcon) {
    <mat-icon [svgIcon]="currentIcon" class="flex flex-[0_0_24px]" />
  }
  <div><div [innerHTML]="title"></div></div>
</div>
